import axios from 'axios'
import router from '../../router'

const state = {
  ViewEstate: [],
  AdminViewEstate: [],
  estateProInfo: []
}

const getters = {
  getViewEstate (state) {
    return state.ViewEstate
  },
  getAdminViewEstate (state) {
    return state.AdminViewEstate
  },
  getViewEstatePro (state) {
    return state.estateProInfo
  }
}

const mutations = {
  setViewEstate (state, payload) {
    state.ViewEstate = payload
  },
  setAdminViewEstate (state, payload) {
    state.AdminViewEstate = payload
  },
  setViewEstatePro (state, payload) {
    state.estateProInfo = payload
  }
}

const actions = {
  apiViewEstateById (context, payload) {
    // console.log(payload)
    return new Promise((resolve, reject) => {
      axios.post('/api/estate/getEstateById', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setViewEstate', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error.response.data.message)
          alert(error.response.data.message)
        })
    })
  },
  apiAdminViewEstateById (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      // console.log(payload)
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/estate/getAdminEstateById', payload)
          .then((response) => {
            console.log(response.data)
            context.commit('setAdminViewEstate', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/AdminLogin')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {

    }
  },
  apiViewEstateProInfo (context, payload) {
    // console.log(payload)
    return new Promise((resolve, reject) => {
      axios.post('/api/estate/getEstateProInfo', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setViewEstatePro', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error.response.data.message)
          // alert(error.response.data.message)
        })
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/viewestate.js